import './style/Divider.css';
import React from 'react';
import { Text } from '@harperai/materialize-design-system';

const Divider = ({ label, width, height, absolute, vertical = false, first = false, last = false }) => {
    return (
        <div className={`keystone-divider ${!width && !vertical && "width-100"} relative`} style={{
            width: (vertical === false && !width) ? "100%" : width ? `${width}px` : "1px",
            position: absolute ? "absolute" : "relative",
            height: height ? height : vertical && !first && !last ? "100%" : vertical && first && !last ? "50%" : vertical && !first && last ? "50%" : "1px",
            left: vertical && "16px",
            top: vertical && !first && "0",
            bottom: vertical && !last && "0",
        }}>
            {label && <Text size="caption" bold={true} variant="secondary">{label}</Text>}
        </div>
    );
};

export default React.memo(Divider);